var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-alert',{directives:[{name:"show",rawName:"v-show",value:(_vm.show),expression:"show"}],staticStyle:{"cursor":"pointer"},attrs:{"title":_vm.title,"type":"success","center":""}})}
var staticRenderFns = []

export { render, staticRenderFns }